import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, PropsWithChildren } from 'react';
import { CardListItemGroup } from 'record-it-components/cardList/CardListItemGroup/CardListItemGroup';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { EntityName } from 'record-it-time-common/EntityName';
import { ImmutableStopwatchInfo } from '../../../classes/timeTracking/ImmutableStopwatch/ImmutableStopwatch';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useGroupedByUserGroup } from '../../../hooks/group/useGroupedByUserGroup/useGroupedByUserGroup';
import { StopwatchListItem } from '../StopwatchListItem/StopwatchListItem';
export type StopwatchListProps = PropsWithChildren<ComponentProps<'div'>> & {
  stopwatchInfos: Array<ImmutableStopwatchInfo>;
};
export const StopwatchList: FunctionComponent<StopwatchListProps> = React.memo(props => {
  const $ = _c(13);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let stopwatchInfos;
  if ($[2] !== t0) {
    ({
      stopwatchInfos,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = stopwatchInfos;
  } else {
    remainingProps = $[3];
    stopwatchInfos = $[4];
  }
  const userGroups = useEntities(EntityName.UserGroup, "getAll");
  const groupedInfos = useGroupedByUserGroup(stopwatchInfos, _temp);
  let t1;
  if ($[5] !== groupedInfos || $[6] !== userGroups) {
    let t2;
    if ($[8] !== userGroups) {
      t2 = group => <CardListItemGroup key={group.key} label={userGroups.length > 1 ? group.label : ""}>{group.items.map(_temp2)}</CardListItemGroup>;
      $[8] = userGroups;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = groupedInfos.map(t2);
    $[5] = groupedInfos;
    $[6] = userGroups;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[10] !== remainingProps || $[11] !== t1) {
    t2 = <div {...remainingProps}>{t1}</div>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
});
function _temp(info) {
  return info.getUserGroupId();
}
function _temp2(info_0) {
  return <StopwatchListItem key={info_0.getId()} stopwatchInfo={info_0} data-testid="StopwatchList.ListItem" />;
}